module.exports = __webpack_public_path__ + "img/Huygenstijdmachine_Mr-August-Fentener.9e3169d7.svg";